/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".avatar[_ngcontent-%COMP%]{width:50px;height:50px}.description[_ngcontent-%COMP%]{font-style:normal;font-weight:300;color:#53585e}.username[_ngcontent-%COMP%]{margin-bottom:0;font-size:16px}"];
export { styles as styles };
